<template>
	<div class="card">
		<div class="card-header bg-dark">
			<h3 class="mb-0 text-white">ตั้งค่าเกม Ambbet</h3>
		</div>
		<el-table header-row-class-name="thead-light" :data="games">
			<el-table-column label="เปิดใช้งาน" min-width="30px">
				<div slot-scope="{ row }" class="text-center">
					<base-checkbox v-model="row.enable" />
				</div>
			</el-table-column>
			<el-table-column label="เกม" min-width="60px">
				<div slot-scope="{ row }">
					{{ row.label }}
				</div>
			</el-table-column>
		</el-table>
		<div class="card-footer text-right">
			<button class="btn btn-default" :disabled="loading" @click="saveSetting">
				บันทึกข้อมูล
			</button>
		</div>
	</div>
</template>

<script>
import { Table, TableColumn } from 'element-ui'

import api from '../../services'

export default {
	props: ['ambbetGames'],
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	data() {
		return {
			loading: false,
			games: [],
		}
	},
	methods: {
		async saveSetting() {
			this.loading = true

			try {
				const res = await api.post('/setting/website/ambbet-games', {
					games: this.games,
				})

				this.$notify({
					type: 'success',
					message: res.message,
				})
			} catch ({ message }) {
				this.$notify({
					type: 'danger',
					message: message,
				})
			} finally {
				this.loading = false
			}
		},
	},
	mounted() {
		this.games = this.ambbetGames
	},
	watch: {
		ambbetGames(v) {
			this.games = v
		},
	},
}
</script>
